import React from 'react'

const Spacer = ({height=100}) => {
  return (
    <div style={{height: height}}></div>
  )
}

export default Spacer